import React, { useState } from "react";
import styles from "../../styles/pages/auth/LoginScreen.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import alertSVG from "../../assets/icons/alert.svg";
import successSVG from "../../assets/icons/success.svg";
import leftArrowSVG from "../../assets/icons/leftArrow.svg";

import Button from "../../ui/buttons/Button";
import BaseInput from "../../ui/inputs/BaseInput/BaseInput";

const RecoverPasswordPage = () => {
  const navigate = useNavigate();
  const { requestPasswordReset, confirmPasswordReset } = useAuth();
  const { uid, token } = useParams();

  const isResetMode = Boolean(uid && token);

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const leftArrowIcon = (
    <img
      src={leftArrowSVG}
      alt=""
      style={{ width: 14, height: 14, display: "block" }}
    />
  );

  const handleRequestSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      setSuccess("");
      setError("El campo mail es requerido");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      setSuccess("");
      setError("El mail no tiene un formato válido");
      return;
    }

    try {
      await requestPasswordReset(trimmedEmail);
      setSuccess(
        "Si existe una cuenta asociada a ese correo, se ha enviado un enlace de recuperación. Por favor revisa tu bandeja de entrada.",
      );
      setError("");
    } catch (err) {
      setSuccess("");
      setError(
        "Hubo un error al enviar la solicitud de recuperación. Por favor, inténtalo nuevamente más tarde.",
      );
      console.error(err?.response?.data || err);
    }
  };

  const validatePasswords = () => {
    if (!newPassword || !reNewPassword) {
      return "Ambos campos de contraseña son requeridos.";
    }
    if (newPassword !== reNewPassword) {
      return "Las contraseñas no coinciden.";
    }
    if (newPassword.length < 8) {
      return "La contraseña debe tener al menos 8 caracteres.";
    }
    return "";
  };

  const handleChangeSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    const validationError = validatePasswords();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      await confirmPasswordReset({ uid, token, new_password: newPassword, re_new_password: reNewPassword });
      navigate("/login");
    } catch (err) {
      setError(
        "Hubo un error al intentar restablecer la contraseña. Verifica el enlace o intenta solicitar uno nuevo.",
      );
      console.error(err?.response?.data || err);
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.leftLogin} />
      <div className={styles.rightLogin}>
        {!isResetMode ? (
          <form onSubmit={handleRequestSubmit} className={styles.formContent}>
            <h1 className={styles.loginTitle}>Recuperar contraseña</h1>
            <h5 className={styles.recoverySubtitle}>
              Ingresa tu correo electrónico y te enviaremos un enlace
              <br />
              para restablecer tu contraseña.
            </h5>

            <BaseInput
              type="email"
              label="Email"
              placeholder="Email"
              value={email}
              onChange={(value) => setEmail(value)}
              validateOnChange={false}
            />

            {error && (
              <div className={styles.loginError}>
                <img src={alertSVG} alt="" aria-hidden="true" />
                {error}
              </div>
            )}

            {success && (
              <div className={styles.successOnRecovery}>
                <img src={successSVG} alt="" aria-hidden="true" />
                {success}
              </div>
            )}

            <Button
              style={{ backgroundColor: "var(--color-brand-500)", minHeight: 45 }}
              type="submit"
              tone="blue"
            >
              Enviar enlace de recuperación
            </Button>

            <Button
              style={{ backgroundColor: "var(--color-brand-500)", minHeight: 45 }}
              tone="blue"
              iconLeft={leftArrowIcon}
              onClick={() => navigate("/login")}
            >
              Volver a Login
            </Button>
          </form>
        ) : (
          <form onSubmit={handleChangeSubmit} className={styles.formContent}>
            <h1 className={styles.loginTitle}>Recuperar contraseña</h1>
            <h5 className={styles.recoverySubtitle}>
              Ingresa tu nueva contraseña
            </h5>

            <BaseInput
              type="password"
              label="Contraseña"
              placeholder="Contraseña"
              value={newPassword}
              onChange={(value) => setNewPassword(value)}
              validateOnChange={false}
            />
            <BaseInput
              type="password"
              label="Repetir Contraseña"
              placeholder="Contraseña"
              value={reNewPassword}
              onChange={(value) => setReNewPassword(value)}
              validateOnChange={false}
            />

            {error && (
              <div className={styles.loginError}>
                <img src={alertSVG} alt="" aria-hidden="true" />
                {error}
              </div>
            )}

            <Button
              style={{ backgroundColor: "var(--color-brand-500)", minHeight: 45 }}
              type="submit"
              tone="blue"
            >
              Aceptar
            </Button>

            <Button
              style={{ backgroundColor: "var(--color-brand-500)", minHeight: 45 }}
              tone="blue"
              iconLeft={leftArrowIcon}
              onClick={() => navigate("/login")}
            >
              Volver a Login
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default RecoverPasswordPage;
